import { useState, useEffect } from "react";

export const useLoadApp = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isAppReady, setIsAppReady] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      const timer = setTimeout(() => {
        setIsAppReady(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [isLoaded]);

  return { isLoaded, isAppReady };
};
